import React from 'react'
import classNames from 'classnames'
import {MINUTES, Period, PERIOD} from "../../enums";
import useChartOptions from "../../hooks/useChartOptions";
import {A, Select, TogglePortal, useToggleContext} from "../index";

export default function ChartOptionsController() {
  const { option, handlePeriod, handleMinutes } = useChartOptions()

  return (
    <Select defaultSelected={PERIOD.DAYS} onChange={handlePeriod}>
      <PeriodOption key={PERIOD.DAYS} period={PERIOD.DAYS}>
        일
      </PeriodOption>
      <PeriodOption key={PERIOD.WEEKS} period={PERIOD.WEEKS}>
        주
      </PeriodOption>
      <PeriodOption key={PERIOD.MONTHS} period={PERIOD.MONTHS}>
        월
      </PeriodOption>
      <TogglePortal
        key={PERIOD.MINUTES}
        trigger={(toggle) => (
          <PeriodOption
            key={PERIOD.MINUTES}
            period={PERIOD.MINUTES}
            onClick={toggle?.open}
          >
            {option.period === 'minutes' ? option.minutes : ''}분
          </PeriodOption>
        )}
        containerSelector=".info_wrap .date"
        content={
          <div className="select_box">
            <Select
              defaultSelected={String(MINUTES[0])}
              onChange={handleMinutes}
            >
              {MINUTES.map((minutes) => (
                <MinutesOption key={minutes} minutes={minutes} />
              ))}
            </Select>
          </div>
        }
      />
    </Select>
  )
}

interface PeriodOptionProps {
  period: Period
  onClick?(): void
  children: React.ReactNode
}

function PeriodOption({ period, onClick, children }: PeriodOptionProps) {
  const { option } = useChartOptions()

  return (
    <A
      key="days"
      className={classNames('btn', {
        select: period === option.period,
        btn_select: period === 'minutes',
      })}
      onClick={onClick}
    >
      {children}
    </A>
  )
}

interface MinutesOptionProps {
  minutes: number
  onClick?(): void
}

function MinutesOption({ minutes, onClick }: MinutesOptionProps) {
  const toggle = useToggleContext()

  return (
    <A
      key={minutes}
      onClick={() => {
        onClick?.()
        toggle?.close()
      }}
    >
      {minutes}분
    </A>
  )
}
